<template>
    <b-radio-group
        v-model="vmodel"
        @input="passInputUp"
    >
        <b-radio :value="1">
            <font-awesome-icon icon="male"></font-awesome-icon> Male
        </b-radio>
        <b-radio :value="0">
            <font-awesome-icon icon="female"></font-awesome-icon> Female
        </b-radio>
    </b-radio-group>
</template>
<script>
export default {
    name        :   "gender-input",
    props       :   {
                        value   :   {
                                        type    :   Number,
                                        default :   null
                                    }
                    },
    data        ()  {
                        return  {
                                    vmodel: this.value
                                };
                    },
    methods     :   {
                        passInputUp(value)  {
                                                this.$emit("input", value);
                                            }
                    }
}
</script>